/*====================================================
	DAWN DEFAULT SCRIPTS
====================================================*/
class SectionId {
	static #separator = '__';

	// for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
	static parseId(qualifiedSectionId) {
		return qualifiedSectionId.split(SectionId.#separator)[0];
	}

	// for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
	static parseSectionName(qualifiedSectionId) {
		return qualifiedSectionId.split(SectionId.#separator)[1];
	}

	// for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
	static getIdForSection(sectionId, sectionName) {
		return `${sectionId}${SectionId.#separator}${sectionName}`;
	}
}

function debounce(fn, wait) {
	let t;
	return (...args) => {
	  clearTimeout(t);
	  t = setTimeout(() => fn.apply(this, args), wait);
	};
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
	window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments);
	};
};

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i];
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i;
			return i;
		}
	}
};

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
	options = options || {};
	var method = options['method'] || 'post';
	var params = options['parameters'] || {};

	var form = document.createElement('form');
	form.setAttribute('method', method);
	form.setAttribute('action', path);

	for (var key in params) {
		var hiddenField = document.createElement('input');
		hiddenField.setAttribute('type', 'hidden');
		hiddenField.setAttribute('name', key);
		hiddenField.setAttribute('value', params[key]);
		form.appendChild(hiddenField);
	}
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
};

/*====================================================
	LATELIER SCRIPTS
====================================================*/
/**
 * Horizontal scroll
 */
const scrollContainers = document.querySelectorAll(".scroll-x-container");

scrollContainers.forEach((scrollContainer) => {
	let isMouseDown = false;
	let startX;
	let scrollLeft;

	scrollContainer.addEventListener("mousedown", (e) => {
		isMouseDown = true;
		scrollContainer.classList.add("grabbing"); // Optional: Add a grabbing cursor class
		startX = e.pageX - scrollContainer.offsetLeft;
		scrollLeft = scrollContainer.scrollLeft;
	});

	scrollContainer.addEventListener("mouseleave", () => {
		isMouseDown = false;
		scrollContainer.classList.remove("grabbing");
	});

	scrollContainer.addEventListener("mouseup", () => {
		isMouseDown = false;
		scrollContainer.classList.remove("grabbing");
	});

	scrollContainer.addEventListener("mousemove", (e) => {
		if (!isMouseDown) return;
		e.preventDefault();
		const x = e.pageX - scrollContainer.offsetLeft;
		const walk = (x - startX) * 1; // Adjust multiplier for scroll speed
		scrollContainer.scrollLeft = scrollLeft - walk;
	});
});

/**
 * Remove empty first <p> element of wysiwyg elements
 */
document.addEventListener("DOMContentLoaded", function () {
	document.querySelectorAll(".text-component, .text-component-small, .text-component-tight").forEach(parent => {
        const firstP = parent.querySelector("p");
        if (firstP && firstP.textContent.trim() === "") {
            firstP.remove();
        }
    });
});

/**
 * Detect when device is touch screen and add class to body
 */
if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
	document.body.classList.add('touch-device');
}

/**
 * Detect when a device uses Safari and add class to body
 */
if ( /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ) {
	document.body.classList.add("safari");
}